// extracted by mini-css-extract-plugin
export default {"container":"dashboard-switch_container__-yYWL","list":"dashboard-switch_list__cZ-TL","empty":"dashboard-switch_empty__tMQba"};